import { Text, FormLabel } from "@chakra-ui/react";
import type { OptionalInputLabelProps } from "./OptionalInputLabel.d";

const OptionalInputLabel = ({ label, optionalText }: OptionalInputLabelProps) => (
  <FormLabel>
    {label}&nbsp;
    <Text fontSize="sm" as="span" color="greyscale.500">
      {optionalText}
    </Text>
  </FormLabel>
);

export default OptionalInputLabel;
